<template>
<div class="form">
  <v-card style="margin-top: 250px">
      <v-breadcrumbs :items="breadcrumbs"></v-breadcrumbs>
      <h1 align="center" style="text-decoration: underline overline;">JR4 - JRB</h1>

      <v-text-field
        outlined 
        dense
        rounded
        v-model="HID"
        label="HID"
        :rules="rules"
        width="20px"
        disabled
      ></v-text-field>



      <v-card>
            <v-card-title>
              JR4 - JRB Punca Pendapatan
            </v-card-title>
            <v-card-text>
              <v-form
                ref="form"
                v-model="valid"
                lazy-validation
              >

                  <!-- S21,S22,S23 -->
                  <v-row>
                    <!-- * Sekiranya jawapan di S19 adalah Ya; atau -->
                    <!-- * Sekiranya jawapan di S37 adalah Ya -->
                    <v-col>
                    S21 : Adakah anda atau ahli isi rumah menerima pendapatan daripada pekerjaan bergaji?
                    <v-select
                      :items="yaTidak"
                      item-text="desc"
                      return-object
                      solo
                      dense
                      v-model="S21"
                      @change="onChangeS21($event)"
                    ></v-select>
                    </v-col>

                    <!-- * Sekiranya jawapan di S21 adalah Tidak -->
                    <v-col v-show="showS22">
                    S22 : Adakah anda atau ahli isi rumah menerima pendapatan sebagai majikan atau bekerja sendiri?
                    <v-select
                      :items="yaTidak"
                      item-text="desc"
                      return-object
                      solo
                      dense
                      v-model="S22"
                      @change="onChangeS22($event)"
                    ></v-select>
                    </v-col>

                    <!-- * Sekiranya jawapan di S22 adalah Ya -->
                    <v-col v-show="showS23">
                    S23 : Apakah sektor pekerjaan anda?
                    <v-select
                      :items="sektorPekerjaan"
                      item-text="desc"
                      return-object
                      solo
                      dense
                      v-model="S23"
                      @change="goToBorang"
                    ></v-select>
                    </v-col>

                  </v-row>
              </v-form>
            </v-card-text>
      </v-card>
</v-card> 

<!-- Error Dialog -->
<v-dialog
      v-model="errorDialog"
      width="500"
      height="200"
    >
    <v-card>
      <v-alert
        dense
        outlined
        color="#C51162"
        type="error"
      >
      <strong>{{errMessage}}</strong>
      </v-alert>
    </v-card>
</v-dialog>

<!-- Success Dialog -->
<v-dialog
      v-model="successDialog"
      width="500"
      height="200"
    >
    <v-card
    color="success"
    >
      <v-alert
        dense
        outlined
        color="#C51162"
        type="success"
      >
      <strong>{{successMessage}}</strong>
      </v-alert>
    </v-card>
</v-dialog>


</div>
</template>
<script>
// import axios from 'axios'

//////////////////////////import services///////////////////
import getLocalStorage from '@/services/getLocalStorage'
const localStorageData = new getLocalStorage(); 

import lookupField from '@/services/lookupField'
const lookupFieldServices = new lookupField();
//////////////////////////end import services//////////////

export default {
    
    async beforeMount(){

        var dataHID = localStorageData.getHIDdata()

        this.HID = dataHID.HID;
        this.BNO = dataHID.BNO;
        this.Ps = dataHID.P;
        this.S = dataHID.S;
        this.NG = dataHID.NG;
        this.DP = dataHID.DP;
        this.DB =  dataHID.DB;
        this.BP = dataHID.BP;
        this.ST = dataHID.ST;
        this.NOTK = dataHID.NOTK;
        this.NOIR = dataHID.NOIR;
        this.Bulan = dataHID.BULAN;
        this.Tahun = dataHID.TAHUN;

        this.currNOAIRData = localStorageData.getCurrentNOAIRData();//dapatkan NOAIR yang di click dari page depan
        this.NOAIR = this.currNOAIRData.NOAIR;

        this.yaTidak = lookupFieldServices.getYaTidak();
        this.sektorPekerjaan = lookupFieldServices.getSektorPekerjaan();

        //this.getData();//dapatkan data based on HID
    },
    setup() {
        
    },
    data: () => ({
        updateButton: true,
        saveButton: false,
        dialog: false,
        successDialog: false,
        errorDialog: false,
        successMessage:'',
        errMessage:'',
        message: "Saving Data",
        popUpALert:false,
        search: '',
        yaTidak:'',
        sektorPekerjaan:'',
        S21:'',
        S22:'',
        S23:'',
        showS22: false,
        showS23: false,
        /////////////////////data declaration//////////////////////////
        HID: '',
        KAW: 1,
        Bulan:'',
        Tahun:'',
        BNO:'',
        Ps:'',
        S:'',
        NG: '',
        DP:'',
        DB:'',
        BP:'',
        ST:'',
        NOTK:'',
        NOIR:'',
        R:1,
        NOAIR:'',
        rules: [
        value => !!value || 'Required.',
      ],
       
       ///////////link untuk ke page/////////////////////
      breadcrumbs: [
        {
          text: 'Status Pengisian',
          disabled: false,
          href: 'ringkasanMaklumatIR',
        },
        {
          text: 'JRB',
          disabled: true,
          href: 'JRB',
        },
      ],
      valid: true,

    }),

    methods: {
      validate () {
        this.$refs.form.validate()
      },
      reset () {
        this.$refs.form.reset()
      },
      resetValidation () {
        this.$refs.form.resetValidation()
      },
      goTo(){
          this.$router.push({name: "hk1"});
      },
      onChangeS21(){

        if(this.S21.id == 1){
          this.goTo();
        }else{
          this.showS22 = true;
        }

      },
      onChangeS22(){
        if(this.S22.id == 1){
          this.showS23 = true;
        }else{
          // if(this.NOAIR == "01"){//changes by SMD 21 Jan
            this.$router.push({name: "hk7"});
          // }else{
          //   this.$router.push({name: "JRD"});
          // }
          
        }
      },
      goToBorang(val){
        var selectedSektor = val.id;
        if(selectedSektor == 1){
          this.$router.push({name: "hk2"});
        }
        if(selectedSektor == 2){
          this.$router.push({name: "hk3"});
        }
        if(selectedSektor == 3){
          this.$router.push({name: "hk4"});
        }
        if(selectedSektor == 4){
          this.$router.push({name: "hk5"});
        }
        if(selectedSektor == 5){
          this.$router.push({name: "hk6"});
        }
        if(selectedSektor == 6){
          if(this.NOAIR == "01"){
            this.$router.push({name: "hk7"});
          }   
        }
        if(selectedSektor == 7){
            if(this.NOAIR == "01"){
              this.$router.push({name: "hk8"});
            }
        }
        
      }
    },

}
</script>

<style>
#app {
  background: url('~@/assets/HIES.jpg')
  no-repeat center center fixed !important;
  background-size: cover;
}

</style>